import { render } from "./DealIntroDemo.vue?vue&type=template&id=16270b06&scoped=true"
import script from "./DealIntroDemo.vue?vue&type=script&lang=js"
export * from "./DealIntroDemo.vue?vue&type=script&lang=js"

import "./DealIntroDemo.vue?vue&type=style&index=0&id=16270b06&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16270b06"]])

export default __exports__